import React, { useEffect, useState } from "react";
import axios from "axios";
// Redux
import { Link,useNavigate  } from "react-router-dom";
import { Row, Col, CardBody, Card, Container, Form, Input, Label, FormFeedback, Alert, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/darklogo.png";
import lightlogo from "../../assets/images/whitelogo.png";

//import thunk
import { loginuser, resetLoginMsgFlag, completeLoginUser } from "slices/auth/login/thunk";

import withRouter from "Components/Common/withRouter";
import { createSelector } from 'reselect';

const Login = (props: any) => {
  const [show, setShow] = useState(false);
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [sessionLimitSessions, setSessionLimitSessions] = useState<any[]>([]);
  const [showSessionModal, setShowSessionModal]         = useState(false);
  const [pendingToken, setPendingToken]                 = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting]                 = useState(false);
  //meta title
  document.title = "Login | BizServe";

  


  const selectProperties = createSelector(
    (state: any) => state.Login,
    (login) => ({
      error: login.error
    })
  );

  const { error } = useSelector(selectProperties);
  const [Two_step, setTwo_step] = useState(false);
  const [useSecret,setUseSecret] = useState(false);
  // Form validation 
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
      otp: "",
      Two_step: false,
     
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your email"),
      password: Yup.string().required("Please Enter Your Password"),
      // otp: Yup.string().required("Enter otp from app")
   
      otp: Yup.string().when("Two_step", {
        is: true,
        then: (schema) =>
          schema.required("Enter code from app").length(6, "Code must be 6 digits"),
        otherwise: (schema) => schema.notRequired(),
      }),

    }),
    onSubmit: (values: any) => {
      if (isSubmitting) return;
      setIsSubmitting(true);
      // dispatch(loginuser(values, props.router.navigate,navigate));
      if(values){
        dispatch(loginuser(values, props.router.navigate,navigate)).then((res) => {console.log("Got response:", res);
          // validation.setFieldValue("Two_step", true);
          // validation.setFieldTouched("otp", false);
          // setTwo_step(true)
          if (res && res.status === "two_fact") {
            validation.setFieldValue("Two_step", true);
            validation.setFieldTouched("otp", false);
            setTwo_step(true);
          } else if (res && res.status === "session_limit") {
            setSessionLimitSessions(res.sessions || []);
            setPendingToken(res.pending_token || null);
            setShowSessionModal(true);
          } else if (res && res.status === "ierror") {
            console.error(res.error);
            validation.setFieldValue("Two_step", false);
            setTwo_step(false);
          }
          setIsSubmitting(false);
        }).catch(() => setIsSubmitting(false));
      }else {
      setIsSubmitting(false);
      setTwo_step(false);
    }
   
    }

  });

  const handleRevokeSession = (jti: string, access_jti?: string) => {
    if (!pendingToken) return;
    setSessionLimitSessions([]);
    setShowSessionModal(false);
    setPendingToken(null);
    dispatch(completeLoginUser(pendingToken, jti, navigate, access_jti));
  };

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        dispatch(resetLoginMsgFlag())
      }, 3000);
    }
  }, [dispatch, error])

  return (
    <React.Fragment>
      <div className="account-pages fullpagebg my-md-0 my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle bgImgGradient">
                  <Row>
                    <Col className="col-7">
                      <div className="text-dark p-4">
                        <h5 className="text-dark">Welcome Back !</h5>
                        <p>Sign in to continue to BizServe.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div className="auth-logo">
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-dark">
                          <img
                            src={lightlogo}
                            alt=""
                            className=""
                            height="38"
                          />
                        </span>
                      </div>
                    </Link>
                    <Link to="/" className="auth-logo-dark">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light border">
                          <img
                            src={logo}
                            alt=""
                            className=""
                            height="38"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-3">
                        {error ? <Alert color="danger">{String(error)}</Alert> : null}
                        <Label className="form-label">Email<span className="text-danger px-1">*</span></Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password<span className="text-danger px-1">*</span></Label>
                        <div className="input-group auth-pass-inputgroup">
                          <Input
                            name="password"
                            className="form-control"
                            placeholder="Enter Password"
                            type={show ? "text" : "password"}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.password || ""}
                            invalid={
                              validation.touched.password && validation.errors.password ? true : false
                            }
                          />
                          <button onClick={() => setShow(!show)} className="btn btn-light " type="button" id="password-addon">
                            <i className="mdi mdi-eye-outline"></i></button>
                          {validation.touched.password && validation.errors.password ? (
                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                          ) : null}
                        </div>
                      </div>

                      {/* <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div> */}

                      {Two_step && !useSecret &&(
                      <div className="mt-4">
                        <div className="d-flex justify-content-between">
                          <Label htmlFor="lastname">Enter your code from the authenticator app.<span className="text-danger px-1">*</span></Label>
                          <a className="text-primary" color="link" type="button" onClick={() => setUseSecret(true)}>
                          More options
                        </a>
                        </div>

                        <Input
                          type="text"
                          id="otp"
                          name="otp"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.otp || ""}
                          placeholder="Enter 6-digit code"
                          maxLength={6}
                          invalid={
                            validation.touched.otp && validation.errors.otp ? true : false
                          }
                        />
                        {validation.touched.otp && validation.errors.otp ? (
                              <FormFeedback type="invalid">{validation.errors.otp}</FormFeedback>
                            ) : null}
                       
                      </div>
                      )}



                      {Two_step && useSecret &&(
                      <div className="mt-4">
                        <div className="d-flex justify-content-between">
                          <Label htmlFor="lastname">Enter your recovery code<span className="text-danger px-1">*</span></Label>
                          <a className="text-primary" color="link" type="button" onClick={() => setUseSecret(false)}>
                          Enable with Passcode
                        </a>
                        </div>

                      
                      <Input
                        type="text"
                        id="otp"
                        name="otp"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.otp || ""}
                        placeholder="Enter the recovery code"
                        maxLength={6}
                        invalid={
                          validation.touched.otp && validation.errors.otp ? true : false
                        }
                      />
                      {validation.touched.otp && validation.errors.otp ? (
                            <FormFeedback type="invalid">{validation.errors.otp}</FormFeedback>
                          ) : null}

                      </div>
                      )}

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            <><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" /> Signing in...</>
                          ) : 'Log In'}
                        </button>
                      </div>
                      

                      {/* <div className="mt-4 text-center">
                        <h5 className="font-size-14 mb-3">Sign in with</h5>

                        <ul className="list-inline">
                          <li className="list-inline-item">
                            <Link
                              to="#"
                              className="social-list-item bg-primary text-white border-primary"
                              onClick={(e: any) => {
                                e.preventDefault();
                                socialResponse("facebook")
                              }}
                            >
                              <i className="mdi mdi-facebook" />
                            </Link>
                          </li>{" "}
                          <li className="list-inline-item">
                            <Link
                              to="#"
                              className="social-list-item bg-info text-white border-info"
                            >
                              <i className="mdi mdi-twitter" />
                            </Link>
                          </li>{" "}
                          <li className="list-inline-item">
                            <Link
                              to="#"
                              className="social-list-item bg-danger text-white border-danger"
                              onClick={(e: any) => {
                                e.preventDefault();
                                socialResponse("google")
                              }}
                            >
                              <i className="mdi mdi-google" />
                            </Link>
                          </li>
                        </ul>
                      </div> */}

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" /> Forgot your
                          password?
                        </Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Don&apos;t have an account ?{" "}
                  <Link
                    to="/register"
                    className="fw-medium text-primary"
                  >
                    {" "}
                    Signup now{" "}
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} BizServe. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by BizServe LLC
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {/* Session limit modal */}
      <Modal isOpen={showSessionModal} toggle={() => setShowSessionModal(false)} centered size="lg">
        <ModalHeader toggle={() => setShowSessionModal(false)}>
          <i className="mdi mdi-devices me-2 text-warning" />
          Active Session Limit Reached
        </ModalHeader>
        <ModalBody>
          <p className="text-muted mb-3">
            You have reached the maximum of <strong>3 active sessions</strong>. Revoke one of the sessions below to continue logging in.
          </p>
          <div className="table-responsive">
            <table className="table table-bordered table-hover align-middle mb-0">
              <thead className="table-light">
                  <tr>
                  <th>Device</th>
                  <th>Browser / OS</th>
                  <th>IP Address</th>
                  <th>Logged In</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {sessionLimitSessions.map((s: any) => {
                  const hasMetadata = s.browser || s.os || s.ip_address;
                  return (
                  <tr key={s.jti}>
                    <td>
                      <i className={`mdi ${s.device_type === 'Mobile' ? 'mdi-cellphone' : s.device_type === 'Tablet' ? 'mdi-tablet' : 'mdi-monitor'} me-1`} />
                      {s.device_type || 'Unknown'}
                      {!hasMetadata && <span className="badge bg-secondary ms-1" style={{ fontSize: '0.65rem' }}>Old session</span>}
                    </td>
                    <td>{[s.browser, s.os].filter(Boolean).join(' / ') || '—'}</td>
                    <td>{s.ip_address || '—'}</td>
                    <td>{s.login_at ? new Date(s.login_at).toLocaleString() : '—'}</td>
                    <td>
                      <Button
                        color="danger"
                        size="sm"
                        onClick={() => handleRevokeSession(s.jti, s.access_jti)}
                      >
                        Revoke
                      </Button>
                    </td>
                  </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowSessionModal(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>

    </React.Fragment>
  );
};

export default withRouter(Login);
